<template>
    <div class="ingreso-documentos">
        <b-collapse :open="openCollapse" class="panel removeShadow" animation="slide" aria-id="contentIdForA11y3">
            <template #trigger="props">
                <div class="card-header" role="button" aria-controls="contentIdForA11y3" :aria-expanded="props.open">
                    <p class="card-header-title collapseHeader" data-testid="collapseButton">
                        Ingresa Obligaciones Manuales (Remuneraciones, Créditos,
                        Documentos Internacionales, Rendiciones).
                    </p>
                    <a class="card-header-icon collapseHeader">
                        <b-icon :icon="props.open ? 'angle-up' : 'angle-down'">
                        </b-icon>
                    </a>
                </div>
            </template>
            <div class="card-content removeShadow collapseBorder">
                <div class="columns is-mobile is-multiline is-vcentered is-justify-content-flex-start mb-6">
                    <div class="column is-12-mobile is-narrow-desktop">
                        <strong>Selecciona documento a ingresar:</strong>
                    </div>
                    <b-field class="column is-flex is-flex-grow-1">
                        <b-select placeholder="Seleccione tipo de obligación" rounded expanded
                            v-model="selectedObligationType" :loading="loading" class="is-primary"
                            data-testid="obligationSelect">
                            <option v-for="option in obligationTypesListFiltered" :value="option.id" :key="option.id"
                                rules="required" name="obligation">
                                {{ option.name }}
                            </option>
                        </b-select>
                    </b-field>
                </div>
                <div v-if="isRemuneration"
                    class="is-flex is-multiline is-variable is-1 is-justify-content-center is-align-items-center is-flex-direction-column">
                    <b-notification style="width:100%" v-if="showWarningOutdatedBook" has-icon :closable="false"
                        type="is-danger is-light" icon="info-circle" aria-close-label="Close notification" role="alert">
                        <p style="padding-top: 11px">
                            Recuerda actualizar tu libro de remuneraciones
                        </p>
                    </b-notification>
                    <p class="has-text-weight-bold mb-4">
                        Ingresa tus Libros de Remuneraciones Mensuales a través
                        de una planilla
                    </p>
                    <b-button type="is-secondary" :icon-right="'upload'"
                        @click="modalBookRemunerations(modalTextsRemunerations)" :disabled="!isBookCompleteTransaction">
                        <span v-if="isBookCompleteTransaction">Subir Libros de Remuneraciones</span>
                        <span v-else>Se está validando tu Libro de Remuneraciones</span>
                    </b-button>
                    <p v-if="!isBookCompleteTransaction" class="has-text-weight-bold has-text-contrast mt-2">
                        Espera a que termine la validación de tu archivo
                        <br />
                    </p>
                    <div v-if="documentHasErrors || isDocumentInvalidBySocket">
                        <br />
                        <error-notification :msg="errorMsg" :type="errorType" />
                    </div>
                    <p v-if="documentIsValidated ||
            (isBookCompleteTransaction &&
                isDocumentValidBySocket)
            " class="has-text-weight-bold has-text-success mt-2">
                        <span>Remuneraciones actualizadas
                        </span>
                        <span>{{
            momentFixed('hasta el mes de',
                webSocketRemunerations.responseMessage
                    .payroll_filled_until
            )
        }}</span>
                        <br />
                    </p>
                    <p class="has-text-grey mt-2">
                        Recuerda que todos los meses debes pedirle a tu Contador
                        el Libro de Remuneraciones y subirlo aquí
                    </p>
                </div>
                <div v-if="edit.obligation_type.name == 'Otras obligaciones'"
                    class="is-flex is-multiline is-variable is-1 is-justify-content-center is-align-items-center is-flex-direction-column">
                    <form-obligation-generic v-bind:key="edit.obligation_type.name"
                        msgTitle="Ingresa documentos Internacionales, Rendiciones y otras obligaciones que no estan en SII, a traves de una planilla"
                        msgBtn="Subir planilla de otras obligaciones"
                        msgValidateBtn="Se está validando tu Libro de otras obligaciones"
                        msgUpdateUntil="Obligaciones actualizadas hasta el mes de"
                        msgNotificationUpdate="Recuerda actualizar tu libro de otras obligaciones"
                        kind_file="other_obligations" :showMsgRemember="false"
                        @open-modal="modalBookRemunerations($event, modalTextsOtherObligations)" />
                </div>
                <ValidationObserver ref="observer" v-slot="{ handleSubmit }" v-if="obligationTypesList" tag="div">
                    <form-obligations :edit="edit" :isAutoGenerated="isAutoGenerated" :isContribution="isContribution"
                        :rutLabel="rutLabel" :isSalary="isSalary" :isRendition="isRendition" :hasRecurrency="hasRecurrency"
                        :initDatepicker="initDatepicker" :minValidFrom="minValidFrom" :rutMask="rutMask"
                        :nameCounterpartLabel="nameCounterpartLabel" :calendarLabel="calendarLabel"
                        :selectableDates="selectableDates" :isTypeDisabled="isTypeDisabled" :amountLabel="amountLabel"
                        :loading="loading" :hideForm="hideForm" @handle-submit="handleSubmit"
                        @call-create-tax-document="callCreateTaxDocument" @on-change-date="onChangeDate" />
                </ValidationObserver>
                <section class="container" v-else>
                    No se pudo obtener la lista de obligaciones.
                </section>
            </div>
        </b-collapse>
    </div>
</template>

<script>
import { checkStatusValidation } from "@/api/s3BookRemunerations";
import BookRemunerations from "@/components/modals/BookRemunerations";
import ErrorNotification from "@/components/obligations/ErrorNotification";
import FormObligationGeneric from "@/components/obligations/formObligationFile/FormObligationGeneric";
import FormObligations from "@/components/obligations/formObligations/FormObligations";
import { consoleHandlerError, notificate } from "@/utils/message";
import SegmentAnalytics from "@/utils/segmentAnalytics";
import { getSuccessMessage } from "@/utils/taxDocumentMessage";
import moment from "moment";
import { ValidationObserver } from "vee-validate";
import { mapActions, mapMutations, mapState } from "vuex";

export default {
    name: "AddObligations",
    components: {
        ErrorNotification,
        FormObligations,
        ValidationObserver,
        FormObligationGeneric,
    },
    data() {
        return {
            edit: {
                document_number: "",
                emitted_at: new Date(),
                payment_period: 30,
                document_type: "P",
                amount: 0,
                counterpart: {
                    rut: "",
                    name: "",
                },
                obligation_type: {
                    id: 1,
                    name: "",
                    associated_document_type: "",
                    enable_recurrent_payment: false,
                },
                recurrency: {
                    id: 0,
                    indefinite_term: false,
                    payment_day: 0,
                    valid_from: new Date(),
                    valid_until: new Date(),
                    amount: 0,
                },
            },
            openCollapse: false,
            rutMask: ["#.###.###-B", "##.###.###-B"],
            loading: false,
            selectedObligationType: 1,
            isIndefiniteTerm: 0,
            today: moment()
                .subtract(1, "days")
                .toDate(),
            initDatepicker: {
                locale: "es",
                "trap-focus": true,
                icon: "calendar-day",
                class: "icon-is-right",
                "nearby-month-days": false,
            },
            ticketTypesHidden: [
                "Boleta electrónica",
                "Boleta exenta electrónica",
            ],
            ticketTypes: [
                "Boleta",
                "Boleta exenta",
                "Boleta electrónica",
                "Boleta exenta electrónica",
            ],
            book: {},
            errorMsg: null,
            errorType: null,
            selectMonth: moment().month(),
            selectYear: moment().year(),
            modalDefault: {
                parent: this,
                hasModalCard: true,
                customClass: "modal-class",
                canCancel: ["escape", "outside"],
            },
            modalTextsOtherObligations: {
                titleModal: "Otras obligaciones manuales",
                msgHelp:
                    "Subir estas obligaciones de forma masiva a\
                    CFOremoto te ayudará a:",
                listHelp: [
                    "Llevar el control de estas obligaciones que no\
                        necesariamente tienen un respaldo en SII.",
                    "Conciliar las salidas de dinero en línea\
                        contra estas obligaciones.",
                    "Incorporar a tu proyección de caja las salidas de\
                        dinero asociados a dichas obligaciones.",
                ],
                planillaName: "libro_de_otras_obligaciones",
                msgFileName: "Otras obligaciones",
                fileName: "Libro de Otras Obligaciones",
                kind_file: "other_obligations",
            },
            modalTextsRemunerations: {
                titleModal: "Libro de remuneraciones",
                msgHelp: "Subir Libro de Remuneraciones te ayudará a:",
                listHelp: [
                    "Tener toda la información de Sueldos,\
                         Imposiciones e Impuestos Únicos históricas.",
                    "Tener una proyección de las salidas de dinero futuras\
                         asociadas a los pagos a tus trabajadores.",
                ],
                planillaName: "libro_de_remuneraciones",
                msgFileName:
                    "Libros de Remuneraciones Mensuales desde\
                                    Enero 2020 hasta el mes en curso",
                fileName: "Libro de Remuneraciones",
                kind_file: "remuneration",
            },
        };
    },
    methods: {
        ...mapActions("taxDocument", [
            "createTaxDocument",
            "createRecurrent",
            "getTotalPay",
            "getTotalCollect",
            "getAllTaxDocuments",
            "getObligationTypesList",
        ]),
        ...mapActions("graphCashFlow", ["getForecastFlowCash"]),
        ...mapActions("bookRemunerations", [
            "startWebSocket",
            "checkStatusValidationDocument",
        ]),
        ...mapMutations("bookRemunerations", [
            "SET_WEBSOCKET",
            "SET_TRANSACTION",
        ]),
        callCreateTaxDocument() {
            this.loading = true;
            if (this.hasRecurrency) {
                this.createRecurrent(this.edit)
                    .then((response) => {
                        new SegmentAnalytics().trackUploadDocument(response);
                        notificate(
                            `<strong>DOCUMENTO RECURRENTE INGRESADO</strong>
                            <br>La recurrencia ha sido agregada exitosamente`,
                            "is-success is-light"
                        );
                        this.getTotalPay();
                        this.getTotalCollect();
                        this.getAllTaxDocuments().catch((error) => {
                            consoleHandlerError({ error, empty: true });
                        });
                    })
                    .catch((error) => {
                        consoleHandlerError({ error });
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            } else {
                this.createTaxDocument(this.edit)
                    .then((response) => {
                        new SegmentAnalytics().trackUploadDocument(response);
                        let message = getSuccessMessage(response);
                        notificate(
                            `<strong>DOCUMENTO INGRESADO</strong><br>El documento
                         ${message} ha sido agregado exitosamente`,
                            "is-success is-light"
                        );
                        this.getTotalPay();
                        this.getTotalCollect();
                        this.getAllTaxDocuments().catch((error) => {
                            consoleHandlerError({ error, empty: true });
                        });
                        this.getForecastFlowCash().catch((error) => {
                            consoleHandlerError({ error, empty: true });
                        });
                    })
                    .catch((error) => {
                        consoleHandlerError({ error });
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        selectableDates(day) {
            return this.selectableDays.includes(day.getDate());
        },
        selectableDatesFromToday(day) {
            return (
                this.selectableDays.includes(day.getDate()) &&
                moment(day).isAfter(this.today)
            );
        },
        selectableDatesBetween(start, end) {
            const range = (start, stop) =>
                Array.from({ length: stop - start + 1 }, (_, i) => start + i);
            return range(start, end);
        },
        selectObligationTypesListFiltered: function () {
            this.getObligationTypesList()
                .then((response) => {
                    if (this.hasSiiAutomation) {
                        this.selectedObligationType = response.filter(
                            (item) => item.sii_code === null
                        )[0].id;
                    }
                })
                .catch((error) => {
                    consoleHandlerError({ error, empty: true });
                });
        },
        cleanForm() {
            this.edit.counterpart.name = "";
            this.edit.counterpart.rut = "";
            this.edit.document_number = "";
            this.edit.emitted_at = new Date();
            this.edit.payment_period = 30;
            this.isIndefiniteTerm = 0;
            this.edit.recurrency.payment_day = new Date();
            this.edit.recurrency.valid_from = new Date();
            this.edit.recurrency.valid_until = new Date();
            this.$refs.observer.reset();
        },
        momentFixed(message, date) {
            const val = moment(date).format("MMMM YYYY");
            if (val == "Fecha inválida") {
                return "";
            }
            return message + ' ' + val;
        },
        updateErrorMsg(msg) {
            this.errorMsg = msg;
            if (msg && "HEADERS_ERRORS" in msg) {
                this.errorType = "HEADERS";
            } else {
                this.errorType = "COLUMNS";
            }
        },
        cleanBookError() {
            this.book.errors = "";
            this.book.validation_status = "P";
        },
        onChangeDate(value) {
            const emitted_at = this.edit.obligation_type.associated_emitted_at;
            if (emitted_at === "last_day_of_month") {
                if (value.toString().length === 4) {
                    this.selectYear = value;
                } else {
                    this.selectMonth = value;
                }

                this.selectableDates = [
                    moment()
                        .year(this.selectYear)
                        .startOf("year")
                        .add(this.selectMonth, "month")
                        .endOf("month")
                        .toDate(),
                ];
            }
        },
        modalBookRemunerations(newProps, modalTextProps) {
            this.$buefy.modal.open({
                ...this.modalDefault,
                component: BookRemunerations,
                props: {
                    book: this.book,
                    ...newProps,
                    ...modalTextProps,
                },
                events: {
                    "clean-error": () => {
                        this.cleanBookError();
                    },
                },
            });
        },
    },
    computed: {
        ...mapState("taxDocument", [
            "taxDocument",
            "obligationTypesList",
            "recurrency",
        ]),
        ...mapState("bookRemunerations", ["webSocketRemunerations"]),
        ...mapState("userAuth", ["user"]),
        obligationTypesListFiltered: function () {
            let obligationList = null;
            if (this.hasSiiAutomation) {
                obligationList = this.obligationTypesList.filter(
                    (item) => item.sii_code === null
                );
            } else {
                obligationList = this.obligationTypesList.filter(
                    (item) => !this.ticketTypesHidden.includes(item.name)
                );
            }
            obligationList = obligationList.filter((obligation) => {
                let obligationIgnored = false;
                obligationIgnored =
                    obligation.name === "Sueldo" ||
                    obligation.name === "IVA" ||
                    obligation.name === "PPM" ||
                    obligation.name === "Retenciones de Honorarios" ||
                    obligation.name === "Impuesto Único" ||
                    obligation.name === "Factura de compra electrónica" ||
                    obligation.name === "Imposiciones" ||
                    obligation.name === "Documento Internacional" ||
                    obligation.name === "Rendición" ||
                    obligation.name === "Finiquito" ||
                    obligation.name === "Dividendo/Retiro" ||
                    obligation.name === "Arriendo/Gastos Comunes" ||
                    obligation.name === "Patente comercial" ||
                    obligation.name === "Impuesto a la Renta" ||
                    obligation.name === "Otro";
                return !obligationIgnored;
            });
            obligationList.push({
                id: 100,
                name: "Otras obligaciones",
                associated_company: null,
                associated_document_type: "",
                associated_emitted_at: null,
                enable_partial_payment: true,
                enable_recurrent_payment: false,
                has_auto_doc_number: false,
                sii_code: null,
            });
            return obligationList;
        },
        documentHasErrors: function () {
            const hasError = this.book.validation_status === "E";
            if (hasError) {
                this.updateErrorMsg(this.book.errors);
            }
            return hasError;
        },
        showWarningOutdatedBook: function () {
            let showWarning = false;
            const responseMessage = this.webSocketRemunerations.responseMessage;
            const payrollLastDate = responseMessage.payroll_filled_until;
            const updateDate = moment(payrollLastDate).add(2, "M");
            const currentDate = Date.now();
            if (payrollLastDate) {
                if (currentDate > updateDate) {
                    showWarning = true;
                }
            }
            return showWarning;
        },
        documentIsValidated: function () {
            return this.book.validation_status === "V";
        },
        isAutoGenerated: function () {
            return this.edit.obligation_type.has_auto_doc_number;
        },
        isSalary: function () {
            return this.edit.obligation_type.name === "Sueldo";
        },
        hideForm: function () {
            const obligationsToHide = ["Remuneraciones", "Otras obligaciones"];
            const obligationName = this.edit.obligation_type.name;
            return !obligationsToHide.includes(obligationName);
        },
        isRemuneration: function () {
            return this.edit.obligation_type.name === "Remuneraciones";
        },
        isRendition: function () {
            return this.edit.obligation_type.name === "Rendición";
        },
        isTicketType: function () {
            return this.ticketTypes.includes(this.edit.obligation_type.name);
        },
        isContribution: function () {
            return this.hasSetCounterpart ? true : false;
        },
        hasRecurrency: function () {
            return this.edit.obligation_type.enable_recurrent_payment;
        },
        hasSetCounterpart: function () {
            return this.edit.obligation_type.associated_company;
        },
        hasSetDocType: function () {
            return this.edit.obligation_type.associated_document_type;
        },
        isBookCompleteTransaction: function () {
            return !!this.webSocketRemunerations.responseMessage
                ?.complete_transaction;
        },
        isDocumentInvalidBySocket: function () {
            let hasError = false;
            if (
                this.webSocketRemunerations.responseMessage
                    ?.validation_status === "E" &&
                this.webSocketRemunerations.responseMessage?.errors !== ""
            ) {
                hasError = true;
            }
            if (hasError) {
                this.updateErrorMsg(
                    this.webSocketRemunerations.responseMessage.errors
                );
            }
            return hasError;
        },
        isDocumentValidBySocket: function () {
            return (
                this.webSocketRemunerations.responseMessage
                    ?.validation_status === "V" || false
            );
        },
        hasSetDateArray: function () {
            let emitted_at = this.edit.obligation_type.associated_emitted_at;
            if (emitted_at && emitted_at === "last_day_of_month") {
                return [
                    moment(this.edit.emitted_at)
                        .endOf("month")
                        .toDate(),
                ];
            }
            return emitted_at;
        },
        isTypeDisabled: function () {
            return this.hasSetDocType ? true : false;
        },
        selectableDays: function () {
            return this.hasSetDateArray
                ? this.hasSetDateArray
                : this.selectableDatesBetween(1, 31);
        },
        minValidFrom: function () {
            if (moment(this.edit.recurrency.valid_from).isAfter(this.today)) {
                return moment(this.edit.recurrency.valid_from).toDate();
            } else {
                return this.today;
            }
        },
        setterValidFrom: function () {
            return this.edit.recurrency.valid_from;
        },
        rutLabel: function () {
            if (this.isSalary) return "RUT Trabajador";
            else if (this.isRendition) return "RUT Rendidor";
            return "RUT Contraparte";
        },
        nameCounterpartLabel: function () {
            if (this.isSalary) return "Nombre Trabajador";
            else if (this.isContribution) return "Nombre Recaudador";
            else if (this.isRendition) return "Rendidor";
            return "Nombre Contraparte";
        },
        calendarLabel: function () {
            if (this.isContribution) return "Fecha límite de pago";
            else if (this.isRendition) return "Fecha de rendición";
            return "Emisión";
        },
        amountLabel: function () {
            if (this.isSalary) return "Monto Líquido";
            else if (this.isContribution && !this.isTicketType)
                return "Monto Total";
            else if (this.isRendition) return "Monto";
            else if (this.isTicketType) return "Monto total del mes";
            return "Monto Bruto";
        },
    },
    watch: {
        isIndefiniteTerm: function () {
            this.edit.recurrency.indefinite_term = !!Number(
                this.isIndefiniteTerm
            );
        },
        selectedObligationType: function () {
            this.edit.obligation_type = this.obligationTypesListFiltered.find(
                (type) => type.id === this.selectedObligationType
            );
            this.cleanForm();
            if (this.hasSetCounterpart) {
                this.edit.counterpart.name = this.hasSetCounterpart.name;
                this.edit.counterpart.rut = this.hasSetCounterpart.rut;
            }
            if (this.hasSetDocType) {
                this.edit.document_type = this.hasSetDocType;
            }
            if (this.hasSetDateArray) {
                const emitted_at = this.edit.obligation_type
                    .associated_emitted_at;
                if (emitted_at !== "last_day_of_month") {
                    this.edit.emitted_at = moment(this.edit.emitted_at)
                        .date(
                            this.edit.obligation_type.associated_emitted_at[0]
                        )
                        .toDate();
                } else {
                    this.edit.emitted_at = moment()
                        .endOf("month")
                        .toDate();
                }
                this.edit.payment_period = 0;
            }
        },
    },
    props: ["hasSiiAutomation"],
    created() {
        this.selectObligationTypesListFiltered();
        checkStatusValidation("remuneration").then((response) => {
            const hasDocumentUploaded = "validation_status" in response.data;
            if (hasDocumentUploaded) {
                const validationStatus = response.data.validation_status;
                const responseMessage = response.data;
                this.book = response.data;
                if (validationStatus === "P") {
                    this.startWebSocket("remuneration");
                } else {
                    this.SET_WEBSOCKET({ responseMessage });
                }
            } else {
                this.SET_TRANSACTION({
                    complete_transaction: true,
                    kind_file: "remuneration",
                });
            }
        });
    },
};
</script>
